import React from 'react'
import { withRouter } from 'react-router-dom'
import { Flex } from 'grid-styled'
import { utils } from 'alelo-logic'
import moment from 'moment'
import { connect } from 'react-redux'
import {
  Container,
  ContainerHeader,
  ContainerIcon,
  EditData,
  EditDataPos,
  EditItem,
  InfoItem,
  InfoItemAdditional,
  ListInfo,
  PaymentFooter,
  PaymentInfo,
  PaymentItem,
  PlanType,
  Title,
  DropdownContainer
} from './styles'
import { showModal } from '../../modules/ModalRoot/actions'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'
import pjImage from '../../../static/icon-veloe-background.svg'
import pfErrorImage from '../../../static/traffic-signal-error.svg'
import Hide from '../../../styles/utilities/Hide'
import DotButton from 'app/elements/DotButton'
import DropdownList, { ListItem as DropListItem } from 'app/modules/IdentifiersList/DropdownList'

import {
  account,
  agency,
  bank,
  card,
  day,
  duoDate,
  final,
  // lateFees,
  monthlyPayment,
  // mulctAndInterest,
  ofEachMonth,
  paymentMethods,
  recharge1,
  recharge2,
  autoRecharge,
  manualRecharge,
  planType
} from './data.json'

import { Icon } from '../../elements/Icon'

const isPos = 'pos'
const isPre = 'pre'

const isAutomatic = 'RECARGA_AUTOMATICA'
const isManual = 'RECARGA_MANUAL'
const paymentTypeCC = 'Cartão de crédito'
const paymentTypeDebit = 'Débito automático'
const paymentTypeTicket = 'Boleto bancário'

class PaymentMethods extends React.Component {
  state = {
    openPaymentModal: false,
    showDropdown: false
  }

  toggleDropdown = () => {
    this.setState(prevState => ({ showDropdown: !prevState.showDropdown }))
  }

  handlePaymentMethodChange = () => {
    const {
      currentPlan,
      plandata,
      match
      //  accountType,
      //   showErrorModal
    } = this.props

    // Removido por ora até ser confirmado que não haverá mais restrição de alteração
    // const ableToChangePaymentMethod =
    //   plandata.authorizations.FORMA &&
    //   !plandata.authorizations.FORMA.dataProximaAlteracao &&
    //   !plandata.authorizations.FORMA.error
    // const daysToChangePaymentMethod =
    //   !ableToChangePaymentMethod && plandata.authorizations.FORMA.dataProximaAlteracao
    //     ? moment(plandata.authorizations.FORMA.dataProximaAlteracao, 'DD/MM/YYYY').diff(
    //         moment(),
    //         'days'
    //       ) + 1
    //     : null

    // if (!ableToChangePaymentMethod) {
    //   showErrorModal(accountType, 'forma de pagamento', daysToChangePaymentMethod)
    // } else {
    this.props.history.push(`/minha-veloe/${match.params.id}/metodo-de-pagamento`, {
      currentPlan,
      paymentTypes: plandata.paymentTypes || []
    })
    // }
  }

  checkChannelAuthorization = () => {
    const { plandata } = this.props
    const regTest = /Alteração não permitida por este canal/
    const matchString =
      plandata.authorizations.FORMA &&
      plandata.authorizations.FORMA.mensagem &&
      plandata.authorizations.FORMA.mensagem.match(regTest)
    if (matchString) return true
    return false
  }

  handleDueDateChange = () => {
    const { currentPlan, plandata, match, accountType, showErrorModal } = this.props

    const ableToChangeDueDate =
      plandata.authorizations.DATA &&
      !plandata.authorizations.DATA.dataProximaAlteracao &&
      !plandata.authorizations.DATA.error
    const daysToChangeDueDate =
      !ableToChangeDueDate && plandata.authorizations.DATA.dataProximaAlteracao
        ? moment(plandata.authorizations.DATA.dataProximaAlteracao, 'DD/MM/YYYY').diff(
            moment(),
            'days'
          ) + 1
        : null

    if (!ableToChangeDueDate) {
      showErrorModal(accountType, 'data de vencimento', daysToChangeDueDate)
    } else {
      this.props.history.push(`/minha-veloe/${match.params.id}/data-de-vencimento`, {
        currentPlan,
        dueDates: plandata.dueDates ? plandata.dueDates.sort((a, b) => a.dia - b.dia) : []
      })
    }
  }

  render() {
    const { showDropdown } = this.state
    const { currentPlan, plandata, creditPaymentInfo, match } = this.props || {}
    const { debitPaymentData } = this.props.currentPlan || {}
    const typeAccountPos = currentPlan.plan.type === isPos
    const finalCreditCardNumber =
      currentPlan.paymentType === 'CARTAO_DE_CREDITO' && creditPaymentInfo.numeroMascarado
        ? creditPaymentInfo.numeroMascarado.split('-')[3]
        : null

    return (
      <Container typeAccountPos={typeAccountPos}>
        <ContainerHeader>
          <Title>{paymentMethods}</Title>
          {currentPlan.plan.type === isPre ? (
            <EditData to={`/minha-veloe/${match.params.id}/editar-dados`}>
              <Hide at="small">
                <Flex>
                  <EditItem typeAccountPos={typeAccountPos}>
                    {planType[currentPlan.plan.type]}
                  </EditItem>
                  <ContainerIcon>
                    <Icon icon="right-arrow" width="8" height="13" viewBox="0 0 8 13" />
                  </ContainerIcon>
                </Flex>
              </Hide>
            </EditData>
          ) : currentPlan.plan.type === isPos && !this.checkChannelAuthorization() ? (
            <DropdownContainer>
              <DotButton onClick={() => this.toggleDropdown()} />
              <DropdownList withIcon isOpen={showDropdown} onClose={() => this.toggleDropdown()}>
                <EditDataPos onClick={this.handlePaymentMethodChange}>
                  <Flex>
                    <ContainerIcon marginLeft="8" alignSelf="center">
                      <Icon icon="money" width="24" height="24" viewBox="0 0 100 100" />
                    </ContainerIcon>
                    <DropListItem>Alterar forma de pagamento</DropListItem>
                  </Flex>
                </EditDataPos>
                <EditDataPos onClick={this.handleDueDateChange}>
                  <Flex>
                    <ContainerIcon marginLeft="8" alignSelf="center">
                      <Icon icon="calendar" width="24" height="24" viewBox="0 0 100 100" />
                    </ContainerIcon>
                    <DropListItem>Alterar data de vencimento</DropListItem>
                  </Flex>
                </EditDataPos>
              </DropdownList>
            </DropdownContainer>
          ) : null}
        </ContainerHeader>
        {currentPlan.plan.type === isPre &&
          currentPlan.plan.rechargeType === isAutomatic && <PlanType>{autoRecharge}</PlanType>}
        {currentPlan.plan.type === isPre &&
          currentPlan.plan.rechargeType === isManual && <PlanType>{manualRecharge}</PlanType>}
        {currentPlan.plan.type === isPos &&
          currentPlan.paymentType === 'CARTAO_DE_CREDITO' && (
            <PlanType typeAccountPos={typeAccountPos}>{paymentTypeCC}</PlanType>
          )}
        {currentPlan.plan.type === isPos &&
          currentPlan.paymentType === 'DEBITO_EM_CONTA' && (
            <PlanType typeAccountPos={typeAccountPos}>{paymentTypeDebit}</PlanType>
          )}
        {currentPlan.plan.type === isPos &&
          currentPlan.paymentType === 'BOLETO' && (
            <PlanType typeAccountPos={typeAccountPos}>{paymentTypeTicket}</PlanType>
          )}
        <PaymentInfo>
          {currentPlan.paymentType === 'CARTAO_DE_CREDITO' &&
            creditPaymentInfo.numeroMascarado && (
              <PaymentItem>
                <ContainerIcon>
                  <Icon icon="card" width="24" height="24" viewBox="0 0 100 100" />
                </ContainerIcon>
                <ListInfo>
                  <InfoItem>{card}</InfoItem>
                  <InfoItemAdditional>
                    {final} {finalCreditCardNumber}
                  </InfoItemAdditional>
                </ListInfo>
              </PaymentItem>
            )}
          {currentPlan.debitPaymentData &&
            currentPlan.paymentType === 'DEBITO_EM_CONTA' &&
            debitPaymentData.bankName &&
            debitPaymentData.bankCode && (
              <PaymentItem typeAccountPos={typeAccountPos}>
                <ContainerIcon>
                  <Icon icon="card" width="24" height="24" viewBox="0 0 100 100" />
                </ContainerIcon>
                <ListInfo>
                  <InfoItem>{bank}</InfoItem>
                  <InfoItemAdditional>{debitPaymentData.bankName}</InfoItemAdditional>
                </ListInfo>
              </PaymentItem>
            )}
          {currentPlan.debitPaymentData &&
            currentPlan.paymentType === 'DEBITO_EM_CONTA' &&
            debitPaymentData.agency &&
            debitPaymentData.account && (
              <PaymentItem grouped>
                <ListInfo>
                  <InfoItem>{agency}</InfoItem>
                  <InfoItemAdditional>{debitPaymentData.agency}</InfoItemAdditional>
                </ListInfo>
                <ListInfo>
                  <InfoItem>{account}</InfoItem>
                  <InfoItemAdditional>{debitPaymentData.account}</InfoItemAdditional>
                </ListInfo>
              </PaymentItem>
            )}
          {plandata &&
            plandata.recharge && (
              <PaymentItem>
                <ContainerIcon>
                  <Icon icon="dollar-sign" width="41" height="41" viewBox="0 0 60 60" />
                </ContainerIcon>
                <ListInfo>
                  <InfoItem>{monthlyPayment[currentPlan.plan.type]}</InfoItem>
                  <InfoItemAdditional>
                    {plandata.recharge !== undefined &&
                      utils.currencyParser(plandata.recharge, 'R$ ')}
                  </InfoItemAdditional>
                </ListInfo>
              </PaymentItem>
            )}
          {currentPlan.plan.type === isPos &&
            currentPlan.posData && (
              <PaymentItem typeAccountPos={typeAccountPos}>
                <ContainerIcon>
                  <Icon icon="calendar" width="24" height="24" viewBox="0 0 100 100" />
                </ContainerIcon>
                <ListInfo>
                  <InfoItem>{duoDate}</InfoItem>
                  <InfoItemAdditional>
                    {day} {currentPlan.posData.dueDayAccount} {ofEachMonth}
                  </InfoItemAdditional>
                </ListInfo>
              </PaymentItem>
            )}
          {/* currentPlan.plan.type === isPre && (
          <PaymentItem grouped typeAccountPos={typeAccountPos}>
            <ContainerIcon>
              <Icon icon="percentual" width="24" height="24" viewBox="0 0 100 100" />
            </ContainerIcon>
            <ListInfo>
              <InfoItem>{lateFees}</InfoItem>
              <InfoItemAdditional>{mulctAndInterest}</InfoItemAdditional>
            </ListInfo>
          </PaymentItem>
        ) */}
          <Hide at="large">
            <Flex mt={20}>
              <EditItem>{planType[this.props.type]}</EditItem>
              <ContainerIcon>
                <Icon icon="right-arrow" width="8" height="13" viewBox="0 0 8 13" />
              </ContainerIcon>
            </Flex>
          </Hide>
        </PaymentInfo>
        {currentPlan.plan.type === isPre &&
          currentPlan.plan.rechargeAmount !== undefined && (
            <PaymentFooter>
              {recharge1}
              {utils.currencyParser(currentPlan.plan.rechargeAmount, 'R$ ')}
              {recharge2}
            </PaymentFooter>
          )}
      </Container>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  showErrorModal: (accountType, label, daysToChange) =>
    dispatch(
      showModal(CONFIRM_UPDATE, {
        modalTitle: `Você fez uma alteração de ${label} recentemente.`,
        modalDescription: (
          <span>
            {daysToChange && (
              <span>
                Em <b>{daysToChange}</b> dia{daysToChange > 1 ? 's' : ''} você poderá fazer uma nova
                alteração.
              </span>
            )}
          </span>
        ),
        accountType,
        image: accountType === 'pf' ? pfErrorImage : pjImage
      })
    )
})

export default connect(null, mapDispatchToProps)(withRouter(PaymentMethods))



// WEBPACK FOOTER //
// ./src/app/modules/PaymentMethods/index.js